import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Spinner from '../../shared/styleguide/Spinner';
import TabNavigation from '../../shared/styleguide/TabNavigation';
var ClientCredentialList = /*#__PURE__*/ React.lazy(function() {
    return import('./ClientCredentialList');
});
var ClientCredentialForm = /*#__PURE__*/ React.lazy(function() {
    return import('./ClientCredentialForm');
});
var ClaimList = /*#__PURE__*/ React.lazy(function() {
    return import('./ClaimList');
});
var menuItems = [
    {
        name: 'client-credentials',
        path: '/client-credentials/credentials',
        label: 'Client Credentials'
    },
    {
        name: 'claims',
        path: '/client-credentials/claims',
        label: 'Scopes'
    }
];
var ClientCredentialsRoutes = function ClientCredentialsRoutes() {
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TabNavigation, {
                items: menuItems
            }),
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(Spinner, {}),
                children: /*#__PURE__*/ _jsxs(Routes, {
                    children: [
                        /*#__PURE__*/ _jsx(Route, {
                            path: "/*",
                            element: /*#__PURE__*/ _jsx(Navigate, {
                                replace: true,
                                to: "/client-credentials/credentials"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: '/credentials/*',
                            element: /*#__PURE__*/ _jsx(ClientCredentialList, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: '/credentials/add',
                            element: /*#__PURE__*/ _jsx(ClientCredentialForm, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: '/credentials/:credentialId',
                            element: /*#__PURE__*/ _jsx(ClientCredentialForm, {})
                        }),
                        /*#__PURE__*/ _jsx(React.Fragment, {
                            children: /*#__PURE__*/ _jsx(Route, {
                                path: '/claims',
                                element: /*#__PURE__*/ _jsx(ClaimList, {})
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export default ClientCredentialsRoutes;
